module.exports = __webpack_public_path__ + "img/samsungtab.aae5873b.png";